module.exports = __webpack_public_path__ + "d78abccf5d2edc671dba13096bb3bffa.MP3";